///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows = abcsetup.workflows || {};
abcsetup.workflows.chart = abcsetup.workflows.chart || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows.chart = {
    cy_chart: null,
    cy_layout: null,
    task : null,

    init: function(editMode = false) {
        // Adjust the card body and workflow chart div height
        this.resize();
        $(window).on('resize', () => this.resize());

        // Build the workflow chart
        this.buildChart(editMode);

        // The workflow task modal has been shown
        $('#workflow-task').on('show.bs.modal', function (e) {
            $(this).find('.modal-body').html('<center>Loading task details...</center>');

            axios.post('/api/workflows/details', {
                task_id: abcsetup.workflows.chart.task.id(),
                workflow_id: abcsetup.workflows.chart.task.data('workflow_id'),
                workflow_task_id: abcsetup.workflows.chart.task.data('workflow_task_id'),
            }).then(response => {
                $(this).find('.modal-body').html(response.data);
                //$(this).find('.datatable').show();
            });
        });

        // Export button was clicked
        $(document).on('click', '#export_btn', function (e) {
            saveAs(abcsetup.workflows.chart.cy_chart.jpg(), 'graph.jpg');
        });
    },

    /**
     * Build the workflow chart
     */
    buildChart: function(editMode = false) {
        cytoscape.use(dagre);
        cyPanzoom(cytoscape, $);

        this.cy_chart = cytoscape({
            container: document.getElementById("workflow-chart"),
            layout: { name: "breadthfirst" },

            minZoom: 0.1,
            maxZoom: 1.5,
            wheelSensitivity : 0.2,
            autounselectify: true,

            // Disable dragging
            autoungrabify: !editMode,

            elements: chart_elements,

            style: [{
                // Base node style
                selector: "node",
                style: {
                    "shape": "roundrectangle",
                    "width": 230,
                    "height": 80,
                    //"border-radius": "8px",
                    "background-color": "#E8E8E8",
                    "label": "data(name)", //editMode ? "data(id)" : "data(name)",
                    "color": "#000000",
                    "text-valign": "center",
                    "text-wrap": "wrap",
                    "text-max-width": 210
                }
            }, {
                // Nodes that are marked done
                selector: "node.done",
                style: {
                    "background-color": "#71D89C",
                }
            }, {
                // Nodes that are marked queued
                selector: "node.queued",
                style: {
                    "background-color": "#FFF388",
                }
            }, {
                // Nodes that are marked reject
                selector: "node.reject.done",
                style: {
                    "background-color": "#F03200",
                    "color": "#ffffff",
                }
            }, {
                selector: "edge",
                style: {
                    "width": 7,
                    "line-color": "#EFEFEF",
                    "target-arrow-color": "#EFEFEF",
                    "target-arrow-shape": "triangle",
                    //"curve-style": "taxi"
                }
             }, {
                // Nodes that are marked done
                selector: "edge.done",
                style: {
                    "line-color": "#71D89C",
                    "target-arrow-color": "#71D89C",
                }
             }, {
                // Edges that are marked queued
                selector: "edge.queued",
                style: {
                    "line-color": "#FFF388",
                    "target-arrow-color": "#FFF388",
                }
            }, {
                // Edges that are marked reject
                selector: "edge.reject.done",
                style: {
                    "line-color": "#F03200",
                    "target-arrow-color": "#F03200",
                }
            }]
        });

        this.cy_layout = this.cy_chart.layout({
            name: "dagre",
            rankDir: "LR",
            fit: true, // whether to fit the viewport to the graph
            directed: false, // whether the tree is directed downwards (or edges can point in any direction if false)
            padding: 30, // padding on fit
            circle: false, // put depths in concentric circles if true, put depths top down if false
            grid: false, // whether to create an even grid into which the DAG is placed (circle:false only)
            spacingFactor: 1.75, // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
            boundingBox: undefined, // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
            avoidOverlap: true, // prevents node overlap, may overflow boundingBox if not enough space
            nodeDimensionsIncludeLabels: false, // Excludes the label when calculating node bounding boxes for the layout algorithm
            roots: undefined, // the roots of the trees
            maximal: true, // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only)
            animate: true, // whether to transition the node positions
            animationDuration: 850, // duration of animation in ms if enabled
            /*
            //animationEasing: 'spring(100, 1)', // easing of animation if enabled,
            animateFilter: function (node, i) {
                return true;
            }, // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
            ready: undefined, // callback on layoutready
            stop: undefined, // callback on layoutstop
            transform: function (node, position) {
                return position;
            }
            */
        });

        // Dynamically change the cursor style to clickable
        this.cy_chart.on('mouseover', 'node.done.clickable, node.queued.clickable', function(e) {
            $('html, body').css('cursor', 'pointer');
        });

        this.cy_chart.on('mouseout', 'node.done.clickable, node.queued.clickable', function(e) {
            $('html, body').css('cursor', 'default');
        });

        // Node tooltips
        // FIXME: This requires https://github.com/cytoscape/cytoscape.js-qtip
        /*
        this.cy_chart.on("mouseover", "node", function(event) {
            var node = event.target;
            node.qtip(
                {
                    content: "hello",
                    show: {
                        event: event.type,
                        ready: true
                    },
                    hide: {
                        event: "mouseout unfocus"
                    }
                },
                event
            );
        });
        */

        // A clickable node was clicked
        this.cy_chart.on('click', 'node.done, node.queued', function(e) {
            $('html, body').css('cursor', 'default');
            abcsetup.workflows.chart.task = e.target;

            // Only show the workflow model if it's not the very first task
            if (abcsetup.workflows.chart.task.data('index') > 0 && abcsetup.workflows.chart.task.data('clickable')) {
                $('#workflow-task').modal('show');
            }
        });

        // Configure the panzoom extension
        this.cy_chart.panzoom({
            zoomFactor: 0.1, // zoom factor per zoom tick
            zoomDelay: 45, // how many ms between zoom ticks
            minZoom: 0.1, // min zoom level
            maxZoom: 1.5, // max zoom level
            fitPadding: 50, // padding when fitting
            panSpeed: 10, // how many ms in between pan ticks
            panDistance: 10, // max pan distance per tick
            panDragAreaSize: 75, // the length of the pan drag box in which the vector for panning is calculated (bigger = finer control of pan speed and direction)
            panMinPercentSpeed: 1, // the slowest speed we can pan by (as a percent of panSpeed)
            panInactiveArea: 8, // radius of inactive area in pan drag box
            panIndicatorMinOpacity: 0.5, // min opacity of pan indicator (the draggable nib); scales from this to 1.0
            zoomOnly: false, // a minimal version of the ui only with zooming (useful on systems with bad mousewheel resolution)
            fitSelector: ':visible', // selector of elements to fit
            animateOnFit: true, // whether to animate on fit
            animateOnZoom: true, // whether to animate on zoom
            fitAnimationDuration: 500, // duration of animation on fit
            sliderHandleIcon: 'fa fa-minus',
            zoomInIcon: 'fa fa-plus',
            zoomOutIcon: 'fa fa-minus',
            resetIcon: 'fa fa-expand',
        });

        this.cy_layout.run();
    },

    /**
     * Adjust the card body and workflow chart div height
     */
    resize: function() {
        $('#card-body').height($(window).height() - 310).show();
        $('#workflow-chart').height($('#card-body').height() - 25);

        if (this.cy_chart) {
            //this.cy_chart.reset();
        }
    },
}
